module.exports = __webpack_public_path__ + "static/contact-hero-deab55aa1e3c3537758efc56dc08543d.jpg";